import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-state", "data-testid"]
const _hoisted_2 = {
  viewBox: "0 0 24 24",
  class: "h-3.5 w-3.5 shrink-0",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]

import type { AffiliateSlaState } from '@/Network/Types/Responses/AntecipeAffiliateResponses'

import { AFFILIATE_SLA_ICON, AFFILIATE_SLA_LABELS, AFFILIATE_SLA_PILL_CLASS } from '../labels'


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateSlaBadge',
  props: {
    state: {},
    testId: { default: 'affiliate-sla-badge' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold", _unref(AFFILIATE_SLA_PILL_CLASS)[_ctx.state]]),
    "data-state": _ctx.state,
    "data-testid": _ctx.testId
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("path", {
        d: _unref(AFFILIATE_SLA_ICON)[_ctx.state]
      }, null, 8, _hoisted_3)
    ])),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createTextVNode(_toDisplayString(_unref(AFFILIATE_SLA_LABELS)[_ctx.state]), 1)
    ])
  ], 10, _hoisted_1))
}
}

})